import React from "react";

export const PageTitle = ({ title, desc, right }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {desc && <p className="mt-1 text-sm text-slate-500">{desc}</p>}
    </div>
    {right}
  </div>
);

export const Table = ({ head, children, testid, empty }) => (
  <div className="rounded-2xl border border-slate-200 overflow-x-auto thin-scroll" data-testid={testid}>
    <table className="w-full text-sm">
      <thead className="bg-white text-left text-[11px] font-mono uppercase tracking-wider text-slate-500">
        <tr>{head.map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}</tr>
      </thead>
      <tbody className="divide-y divide-slate-200 text-slate-600">{children}</tbody>
    </table>
    {empty && <p className="p-6 text-sm text-slate-500 text-center">{empty}</p>}
  </div>
);

export const Td = ({ children, className = "" }) => <td className={`px-4 py-3 align-middle ${className}`}>{children}</td>;

export const fmtDate = (d) => (d ? new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const StatCard = ({ label, value, sub, testid, accent = "text-slate-900" }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <div className="text-xs font-mono uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`mt-2 font-display text-3xl font-bold ${accent}`}>{value}</div>
    {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
  </div>
);
